
export const GraphQLDataApiActions = {
  REQUEST_INIT: 'REQUEST_INIT',
  REQUEST_SUCCESS: 'REQUEST_SUCCESS',
  REQUEST_ERROR: 'REQUEST_ERROR',
};
